/**
  * Popup-Element
  * @namespace v3sWbtPlayerApp:page:popup
  */

/**
 * Definiert die v3s-popup Direktive.
 * @class directive_v3sPopup
 * @memberOf v3sWbtPlayerApp:page:popup
 * @param {number} id - Popup-Id
 * @param {string} v3s-type - Typ des Popups (paragraph, example, ...)
 * @example
 * <v3s-popup id="P2" v3s-type="example">
 *   <v3s-data v3s-textalign="left" v3s-verticalalign="top">1. Beispiel und 2. Beispiel.</v3s-data>
 *   <v3s-graphic v3s-file="./img/s_example.jpg" v3s-align="left" v3s-float="true"/>
 * </v3s-popup>
 */
angular.module('v3sWbtPlayerApp').directive('v3sPopup', ["v3sPopupService", "$sce","$document", function (v3sPopupService, $sce,$document) {
    return {
        restrict: 'E',
        require: ['^^v3sDocument'],
        //transclude: true,
        //template: '<div ng-class="{\'with-title\' : v3sTitle}"class="v3s-popup-header v3s-icon v3s-icon-{{v3sType}}"><div>{{v3sTitle}}</div><button class="close"></button></div><div class="v3s-popup-container"><div class="v3s-popup-container-data" ng-transclude></div></div>',
        scope: {
            id: '@',
            v3sStyle: '@',
            v3sType: '@',
            v3sWidth: '@',
            v3sHeight: '@',
            v3sTitle: '@',
            v3sShowtitle: '@'
        },

        link: function (scope, element) {
            //Parse Content
            //Die Grafik muss je nach vertikalen Alignment, vor oder nach dem Text angeordnet werden im DOM
            var v3sGraphic = angular.element(element[0].querySelector('v3s-graphic'));
            var v3sData = angular.element(element[0].querySelector('v3s-data'));
            if (!!v3sGraphic && !!v3sData) {
                var valign = v3sGraphic.attr('v3s-verticalalign');
                var halign = v3sGraphic.attr('v3s-align');

                var prependGraphic = (valign === "top" || (valign === "middle" && halign === "left"))
                if (prependGraphic) {
                    if (valign == "middle") {
                        element.prepend(v3sGraphic);
                    } else {
                        v3sData.prepend(v3sGraphic);
                    }
                }

                if (valign == "middle") {
                    var wrapper = angular.element("<div class='popup-with-vertical-centered-image'></div>");
                    wrapper.append(element.children());
                    element.append(wrapper);
                }
            }

            //popuptyp setzen
            v3sPopupService.setPopupType(scope.id, scope.v3sType);

            //Warten, bis alles gerendert ist...
            $document.ready(function () {
                v3sPopupService.addPopup({
                    "id": scope.id,
                    "type": scope.v3sType,
                    "isCarousel" : scope.v3sStyle == "carousel",
                    "valign" : valign,
                    "width": scope.v3sWidth,
                    "height" : scope.v3sHeight != "" ? scope.v3sHeight : false,
                    "title": scope.v3sTitle,
                    "showTitle": scope.v3sShowtitle,
                    "content" : $sce.trustAsHtml(element.html())
                });

            })

            scope.$on("$destroy", function () {
                v3sPopupService.destroy();
            })
        }

    }
}]);